import React from "react";

import { cn } from "@/utils/cn";

import Text from "../text/text";

import type { Sizes as TextSizes } from "../text/text";

interface DividerProps {
  text?: string | React.ReactNode;
  textSize?: TextSizes;
  className?: string;
}

/** Divider */
const Divider = ({ className, text, textSize = "md" }: DividerProps) => (
  <div className={cn(className, "relative")} data-testid="divider">
    <div className="absolute inset-0 flex items-center" aria-hidden="true">
      <div className="w-full border-t" />
    </div>

    {text && (
      <div className="relative flex justify-center">
        <span
          className="bg-background px-2 text-foreground"
          data-testid="divider-text"
        >
          <Text size={textSize} tag="span" theme="inherit">
            {text}
          </Text>
        </span>
      </div>
    )}
  </div>
);

export default Divider;
